module.exports = __webpack_public_path__ + "img/seated.f456add3.svg";